import { Card, Group, Text } from "components/common"
import { useTranslation } from "react-i18next"
import { convertToReadableString } from "utils"
import { formatTimeString } from "utils/date"
import styles from "./callsTab.module.less"
import cx from "clsx"

function CallSummary({ callDetail }) {
  const { t } = useTranslation()

  return (
    <Group gap="24px">
      <div>{callDetail?.summary?.description}</div>
      <Group template="40% 60%" gap="20px">
        <div>
          <Text type={"secondary"}>{t("Project Discussed")}</Text>
          <div className="semiBold">
            {callDetail?.summary?.projectDiscussed
              ? convertToReadableString(callDetail?.summary?.projectDiscussed)
              : "-"}
          </div>
        </div>
        <div>
          <Text type={"secondary"}>{t("Next Proposed Meeting")}</Text>
          <div className="semiBold">{convertToReadableString(callDetail?.summary?.nextProposedTask)}</div>
        </div>
      </Group>
      {callDetail?.summary?.meeting && (
        <div>
          <Text type="secondary">{t("Meeting Information")}</Text>
          <Card variant="fill" style={{ borderColor: "#C7DEFC" }}>
            <Group template="40% 60%" gap="20px">
              <div>
                <Text type="secondary">{t("Probability")}</Text>
                <div className="semiBold">
                  {convertToReadableString(callDetail?.summary?.meeting?.probability) ||
                    callDetail?.summary?.meeting?.next_meeting_probability}
                </div>
              </div>
              <div>
                <Text type="secondary">{t("Date/Time")}</Text>
                <div className="semiBold">
                  {callDetail?.summary?.meeting?.date || callDetail?.summary?.meeting?.next_meeting_date}{" "}
                  {callDetail?.summary?.meeting?.time
                    ? callDetail?.summary?.meeting?.time
                    : formatTimeString(callDetail?.createdAt)}
                </div>
              </div>
              <div>
                <Text type="secondary">{t("Venue")}</Text>
                <div className="semiBold">
                  {convertToReadableString(
                    callDetail?.summary?.meeting?.venue || callDetail?.summary?.meeting?.next_meeting_venue || ""
                  )}
                </div>
              </div>
            </Group>
          </Card>
          {callDetail?.summary?.minutesOfMeeting && (
            <div style={{ marginTop: 15 }}>
              <Text type="secondary">{t("Minutes of Meeting")}</Text>
              <Card variant="fill" style={{ borderColor: "#C7DEFC" }}>
                {callDetail?.summary?.minutesOfMeeting &&
                  callDetail?.summary?.minutesOfMeeting
                    ?.split(".,")
                    .map((item, index) => <Text>{convertToReadableString(item)}</Text>)}
              </Card>
            </div>
          )}
        </div>
      )}
    </Group>
  )
}

export default CallSummary
